import React, { useState } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import Swal from "sweetalert2";

const API_HOST = process.env.REACT_APP_API_URL;
const API = process.env.REACT_APP_API_KEY;

const FormularioReempaquePublico = () => {
  const [clienteReempaque, setClienteReempaque] = useState({
    nombre: "",
    correo: "",
    telefono: "",
    casillero: "",
    faltanMasTrackings: false,
    idCliente: null,
  });

  const [paquetesSeleccionados, setPaquetesSeleccionados] = useState([]);
  const [paqueteActual, setPaqueteActual] = useState({
    tracking: "",
    tienda: "",
  });

  const [clienteValidado, setClienteValidado] = useState(false);
  const [buscando, setBuscando] = useState(false);

  const styles = {
    background: {
      background: "linear-gradient(135deg, #4b6cb7 0%, #182848 100%)",
      minHeight: "100vh",
      padding: "2rem 0",
    },
    card: {
      border: "none",
      borderRadius: "15px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2)",
      overflow: "hidden",
      width: "100%",
      margin: "0 auto",
      backgroundColor: "#ffffff",
      height: "100%",
    },
    cardHeader: {
      background: "#3a5a8a",
      color: "white",
      padding: "1.5rem",
      marginBottom: "1.5rem",
      borderBottom: "3px solid #2c4365",
    },
  };

  const handleValidarCliente = async () => {
    setBuscando(true);
    try {
      const response = await fetch(`${API_HOST}/reempaques/validar-cliente`, {
        method: "POST",
        headers: { "Content-Type": "application/json", API: API },
        body: JSON.stringify({
          nombre: clienteReempaque.nombre,
          correo: clienteReempaque.correo,
          telefono: clienteReempaque.telefono,
          casillero: clienteReempaque.casillero,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setClienteValidado(true);
        setClienteReempaque((prevState) => ({
          ...prevState,
          idCliente: data.idCliente,
        }));
        Swal.fire("Cliente validado", "Puede proceder a agregar sus paquetes.", "success");
      } else {
        Swal.fire("Error", data.message || "Cliente no encontrado o no autorizado.", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Error de conexión", "error");
    } finally {
      setBuscando(false);
    }
  };

  const handleAgregarPaquete = async () => {
    if (!paqueteActual.tracking || !paqueteActual.tienda) {
      Swal.fire("Atención", "Ingrese tracking y tienda.", "warning");
      return;
    }

    if (paquetesSeleccionados.some((p) => p.tracking === paqueteActual.tracking)) {
      Swal.fire("Error", "Ya agregaste este tracking a la lista actual.", "error");
      return;
    }

    try {
      const response = await fetch(
        `${API_HOST}/paquetes/verificar-disponibilidad/${paqueteActual.tracking}`,
        {
          headers: { API: API, "Content-Type": "application/json" },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Tracking no válido o ya asignado");
      }

      setPaquetesSeleccionados([...paquetesSeleccionados, paqueteActual]);
      setPaqueteActual({ tracking: "", tienda: "" });
    } catch (error) {
      Swal.fire("No disponible", error.message, "error");
    }
  };

  const handleEliminarPaquete = (index) => {
    const nuevosPaquetes = paquetesSeleccionados.filter((_, i) => i !== index);
    setPaquetesSeleccionados(nuevosPaquetes);
  };

  const handleEnviarSolicitud = async (e) => {
    e.preventDefault();

    if (paquetesSeleccionados.length === 0) {
      Swal.fire({
        icon: "error",
        title: "Lista vacía",
        text: "Debe agregar al menos un paquete para solicitar el reempaque.",
        confirmButtonColor: "#3a5a8a",
      });
      return;
    }

    Swal.fire({
      title: "Enviando solicitud...",
      text: "Por favor espere mientras procesamos su reempaque.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      const payload = {
        idCliente: clienteReempaque.idCliente,
        faltanPaquetes: clienteReempaque.faltanMasTrackings || false,
        paquetes: paquetesSeleccionados.map((pkg) => ({
          tracking: pkg.tracking,
          tienda: pkg.tienda,
        })),
      };

      const response = await fetch(`${API_HOST}/reempaques/public`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          API: API,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Error al procesar la solicitud en el servidor.");
      }

      Swal.fire({
        icon: "success",
        title: "¡Solicitud enviada!",
        text: "Tu solicitud de reempaque ha sido recibida con éxito.",
        confirmButtonColor: "#3a5a8a",
      }).then(() => {
        setClienteReempaque({
          nombre: "",
          correo: "",
          telefono: "",
          casillero: "",
          faltanMasTrackings: false,
          idCliente: null,
        });
        setPaquetesSeleccionados([]);
        setPaqueteActual({ tracking: "", tienda: "" });
        setClienteValidado(false);
      });
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Hubo un problema al intentar enviar la solicitud.",
        confirmButtonColor: "#3a5a8a",
      });
    }
  };

  return (
    <div style={styles.background}>
      <Container>
        <Row className='justify-content-center mb-4'>
          <Col xs={12} className='text-center'>
            <h2
              className='text-white mb-2'
              style={{
                fontWeight: "700",
                textShadow: "1px 1px 3px rgba(0,0,0,0.3)",
              }}
            >
              Solicitud de Reempaque
            </h2>
            <p className='lead text-light' style={{ fontWeight: "500" }}>
              Unifica tus paquetes para ahorrar en costos de envío
            </p>
          </Col>
        </Row>
        <Row className='g-4 justify-content-center'>
          <Col lg={5}>
            <Card style={styles.card} className='h-100'>
              <div style={styles.cardHeader}>
                <h3 className='mb-0'>Instrucciones y Datos</h3>
              </div>
              <Card.Body className='p-4'>
                <div className='alert alert-info mb-4' role='alert'>
                  <h5 className='alert-heading fw-bold'>Por favor lea atentamente:</h5>
                  <ol className='mb-0 ps-3'>
                    <li>Complete toda la información y valide su cliente.</li>
                    <li>Una vez validado, podrá ingresar sus trackings manualmente.</li>
                  </ol>
                </div>

                <Form>
                  <h5 className='mb-3 fw-bold border-bottom pb-2'>Datos del Cliente</h5>
                  <Form.Group className='mb-3'>
                    <Form.Label>Nombre Completo</Form.Label>
                    <Form.Control
                      type='text'
                      disabled={clienteValidado}
                      value={clienteReempaque.nombre}
                      onChange={(e) =>
                        setClienteReempaque({ ...clienteReempaque, nombre: e.target.value })
                      }
                    />
                  </Form.Group>
                  <Row>
                    <Col md={6}>
                      <Form.Group className='mb-3'>
                        <Form.Label>Teléfono</Form.Label>
                        <Form.Control
                          type='text'
                          disabled={clienteValidado}
                          value={clienteReempaque.telefono}
                          onChange={(e) =>
                            setClienteReempaque({ ...clienteReempaque, telefono: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className='mb-3'>
                        <Form.Label>N° de Casillero</Form.Label>
                        <Form.Control
                          type='text'
                          placeholder='Ej. MBOX-1234'
                          disabled={clienteValidado}
                          value={clienteReempaque.casillero}
                          onChange={(e) =>
                            setClienteReempaque({ ...clienteReempaque, casillero: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group className='mb-4'>
                    <Form.Label>Correo Electrónico</Form.Label>
                    <Form.Control
                      type='email'
                      disabled={clienteValidado}
                      value={clienteReempaque.correo}
                      onChange={(e) =>
                        setClienteReempaque({ ...clienteReempaque, correo: e.target.value })
                      }
                    />
                  </Form.Group>

                  <div className='d-grid'>
                    <Button
                      variant='primary'
                      onClick={handleValidarCliente}
                      disabled={buscando || clienteValidado}
                      style={{ backgroundColor: "#3a5a8a", borderColor: "#3a5a8a" }}
                    >
                      {buscando
                        ? "Validando..."
                        : clienteValidado
                        ? "Cliente Validado"
                        : "Validar Cliente"}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>

          <Col lg={7}>
            <Card style={styles.card} className='h-100'>
              <div style={styles.cardHeader}>
                <h3 className='mb-0'>Selección de Paquetes</h3>
              </div>
              <Card.Body className='p-4'>
                <div className='p-3 mb-4 bg-light rounded border'>
                  <Row className='align-items-end'>
                    <Col md={5} className='mb-3 mb-md-0'>
                      <Form.Group>
                        <Form.Label className='fw-bold'>Número de Tracking</Form.Label>
                        <Form.Control
                          type='text'
                          placeholder='Ingrese tracking manual'
                          disabled={!clienteValidado}
                          value={paqueteActual.tracking}
                          onChange={(e) =>
                            setPaqueteActual({ ...paqueteActual, tracking: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={5} className='mb-3 mb-md-0'>
                      <Form.Group>
                        <Form.Label className='fw-bold'>Tienda de Compra</Form.Label>
                        <Form.Control
                          type='text'
                          placeholder='Ej. Amazon, Shein'
                          disabled={!clienteValidado}
                          value={paqueteActual.tienda}
                          onChange={(e) =>
                            setPaqueteActual({ ...paqueteActual, tienda: e.target.value })
                          }
                        />
                      </Form.Group>
                    </Col>
                    <Col md={2} className='d-grid'>
                      <Button
                        variant='success'
                        onClick={handleAgregarPaquete}
                        disabled={!clienteValidado}
                      >
                        Agregar
                      </Button>
                    </Col>
                  </Row>

                  <Form.Check
                    type='checkbox'
                    className='mt-3'
                    label='¿Faltan más trackings por llegar?'
                    disabled={!clienteValidado}
                    checked={clienteReempaque.faltanMasTrackings || false}
                    onChange={(e) =>
                      setClienteReempaque({
                        ...clienteReempaque,
                        faltanMasTrackings: e.target.checked,
                      })
                    }
                  />
                </div>

                <h5 className='mb-3 fw-bold border-bottom pb-2'>Paquetes a Reempacar</h5>
                {paquetesSeleccionados.length === 0 ? (
                  <p className='text-center text-muted my-4'>No se han agregado paquetes.</p>
                ) : (
                  <div className='table-responsive mb-4'>
                    <table className='table table-bordered table-hover'>
                      <thead className='table-light'>
                        <tr>
                          <th>#</th>
                          <th>Tracking</th>
                          <th>Tienda</th>
                          <th className='text-center'>Acción</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paquetesSeleccionados.map((pkg, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1}</td>
                            <td>{pkg.tracking}</td>
                            <td>{pkg.tienda}</td>
                            <td className='text-center'>
                              <Button
                                variant='outline-danger'
                                size='sm'
                                onClick={() => handleEliminarPaquete(idx)}
                              >
                                Quitar
                              </Button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className='d-flex justify-content-end mt-4 pt-3 border-top'>
                  <Button
                    variant='primary'
                    size='lg'
                    onClick={handleEnviarSolicitud}
                    disabled={!clienteValidado || paquetesSeleccionados.length === 0}
                    style={{ backgroundColor: "#3a5a8a", borderColor: "#3a5a8a" }}
                  >
                    Enviar Solicitud de Reempaque
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FormularioReempaquePublico;
